import { render, staticRenderFns } from "./secondBlogRow.vue?vue&type=template&id=79e6d78e&"
import script from "./secondBlogRow.vue?vue&type=script&lang=js&"
export * from "./secondBlogRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports